
import { MST_STATUS } from './../model/status.model';
import { MST_DISTANCE } from '../model/transportation.model';
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from "../../environments/environment";
import { User } from "../model/user.model";
import { QuotationSearch, TRN_QUOTATION, QuotationType, QuotationSubType, PriceRate, SalePerson, QuotationCondition, QuotationSave, TRANSPORTATION_DESCRIPTION, ProductDescription, paramGetProduct, TRN_SUB_QUOTATION, QuotationApproveData, LIST_CUSTOMER, CustomerSite, QuotationProduct, QuotationDocNoParam, DOCNO, ApproverData, paramGetCondition, Product } from '../model/quotation.model';
import { LIST_COMPANY_BRANCH } from '../model/CompanyBranch.model';
import { pipe } from 'rxjs';
import { ApiResponse } from '../model/common.model';



const API_URL = environment.apiUrl;
const httpOptions = {
    headers: new HttpHeaders(
        {
            'Content-Type': 'application/json',
        }
    )
};

@Injectable()
export class QuotationService {
    private Url = '';  // URL to web api
    currentUser: User;

    constructor(
        private http: HttpClient) {
        this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
        this.Url = API_URL + '/' + (this.currentUser.CompanyID ? this.currentUser.CompanyID.toString() : "1") + '/quotation';
    }


    GetQuotationList(model: QuotationSearch): Observable<ApiResponse<TRN_QUOTATION[]>> {
        return this.http.post<ApiResponse<TRN_QUOTATION[]>>(this.Url + "/GetQuotationList", model, httpOptions)
            .pipe(
                tap(response => { })
            );
    }

    GetApproverList():Observable<ApproverData[]>
    {
        return this.http.get<ApproverData[]>(this.Url + "/GetApproverList", httpOptions)
        .pipe
        (
            tap(response => { })
        )
    }

    GetQuotationApprovalList(model: QuotationSearch): Observable<TRN_QUOTATION[]> {
        return this.http.post<TRN_QUOTATION[]>(this.Url + "/GetQuotationApprovalList", model, httpOptions)
            .pipe(
                tap(response => { })
            );
    }

    GetQuotationStatus(): Observable<MST_STATUS[]> {
        return this.http.get<MST_STATUS[]>(this.Url + "/GetQuotationStatus", httpOptions)
            .pipe(
                tap(response => { })
            );
    }

    GetListQuotationType():Observable<QuotationType[]>
    {
        return this.http.get<QuotationType[]>(this.Url + "/GetListQuotationType", httpOptions)
        .pipe(
            tap(response =>{})
        )
    }

    GetListPriceRate(id:string):Observable<PriceRate[]>
    {
        return this.http.get<PriceRate[]>(this.Url + "/GetListPriceRate/"+id, httpOptions)
        .pipe(
            tap(response =>{})
        )
    }

    GetListSalePerson(id:number):Observable<SalePerson[]>
    {
        return this.http.get<SalePerson[]>(this.Url + "/GetSalePerson/" + id, httpOptions)
        .pipe
        (
            tap(response => {})
        )
    }

    GetListQuotationSubType():Observable<QuotationSubType[]>
    {
        return this.http.get<QuotationSubType[]>(this.Url + "/GetListQuotationSubTypeCR", httpOptions)
        .pipe(
            tap(response =>{})
        )
    }

    GetListCompanyBranch():Observable<LIST_COMPANY_BRANCH[]>
    {
        return this.http.get<LIST_COMPANY_BRANCH[]>(this.Url + "/GetListCompanyBranch", httpOptions)
            .pipe
            (
                tap(response => {})
            );
    }

    GetCondition(param:paramGetCondition):Observable<QuotationCondition[]>
    {
        return this.http.post<QuotationCondition[]>(this.Url + "/GetConditionBySubType",param, httpOptions)
            .pipe
            (
                tap(response => {})
            );
    }

    GetConditionByID(id:number):Observable<QuotationCondition[]>
    {
        return this.http.get<QuotationCondition[]>(this.Url + "/GetConditionByID/" + id, httpOptions)
        .pipe
        (
            tap(response => {})
        )
    }

    SaveQuotation(data:QuotationSave):Observable<any>
    {
        console.log("Service");
        return this.http.post<any>(this.Url + "/SaveQuotation", data, httpOptions)
        .pipe(
            tap(response => {})
        )
    }

    CheckQuotation(data:QuotationSave):Observable<any>
    {
        return this.http.post<any>(this.Url + "/CheckQuotation", data, httpOptions)
        .pipe(
            tap(response => {})
        )

    }

    UpdateQuotation(data:QuotationSave):Observable<any>
    {
        console.log("Service");
        return this.http.post<any>(this.Url + "/UpdateQuotation", data, httpOptions)
        .pipe(
            tap(response => {})
        )
    }

    UpdateQuotationStatus(data: Array<TRN_QUOTATION>): Observable<any> {
        return this.http.post<any>(this.Url + "/UpdateQuotationStatus", data, httpOptions)
            .pipe(
                tap(response => { })
            );
    }

    GetTransportationDiscription(code:number):Observable<any>
    {
        return this.http.post<TRANSPORTATION_DESCRIPTION[]>(this.Url + "/GetTransportationDiscription" ,code, httpOptions)
        .pipe(
            tap(response => { })
        );
    }

    GetSubQuotationByID(id:number):Observable<TRN_SUB_QUOTATION[]>
    {
        return this.http.get<TRN_SUB_QUOTATION[]>(this.Url + "/GetSubQuotationByID/" + id, httpOptions)
        .pipe
        (
            tap(response => { })
        )
    }

    ProductByID(id:number):Observable<Product>
    {
        return this.http.get<Product>(this.Url + "/ProductByID/" + id, httpOptions).pipe
        (
            tap(response =>{})
        )
    }


    GetProductDescription(data:paramGetProduct):Observable<ProductDescription[]>
    {
        return this.http.post<ProductDescription[]>(this.Url + "/GetProductDescription", data, httpOptions)
        .pipe
        (
            tap(response => { })
        );
    }


    GetQuotationForExport(search: QuotationSearch, type: number): Observable<any> {

        return this.http.post(this.Url + '/GetQuotationForExport/' + type, search, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',

            }),
            responseType: 'arraybuffer'
        }).pipe(tap((x) => {
        }),
            catchError(this.handleError<QuotationSearch>('GetQuotationForExport'))
        );
    }

    GetQuotationByID(id:number):Observable<TRN_QUOTATION>
    {
        return this.http.get<TRN_QUOTATION>(this.Url + '/GetQuotationByID/' + id, httpOptions)
        .pipe
        (
            tap(response => { })
        );
    }

    GetCustomerSiteList(id:number):Observable<CustomerSite[]>
    {
        return this.http.get<CustomerSite[]>(this.Url + "/GetCustomerSiteList/" + id , httpOptions)
        .pipe
        (
            tap(response => { })
        )
    }

    GetProductList(Type:string):Observable<QuotationProduct[]>
    {
        return this.http.get<QuotationProduct[]>(this.Url + "/GetProductList/" + Type, httpOptions)
        .pipe(
            tap(response => { })
        )
    }

    GetQuotationDocNo(data:QuotationDocNoParam):Observable<DOCNO>
    {
        return this.http.post<DOCNO>(this.Url + "/GetQuotationDocNo",data, httpOptions)
        .pipe
        (
            tap(response => { })
        )
    }

    GetCustomerList():Observable<LIST_CUSTOMER[]>
    {
        return this.http.get<LIST_CUSTOMER[]>(this.Url + "/GetCustomerList", httpOptions)
        .pipe
        (
            tap(response => { })
        )
    }

    DownloadQuotationreport(QuotationID:number):Observable<any>
    {
        // return this.http.get<any>(this.Url + "/QuotationSaleReport/" + QuotationID, httpOptions)
        //     .pipe
        //     (
        //         tap(response => {})
        //     )


            return this.http.get(this.Url + '/QuotationSaleReport/' + QuotationID, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',

                }),
                responseType: 'arraybuffer'
            }).pipe(tap((x) => {
            }),

            );
    }

    /**
     * Handle Http operation that failed.
     * Let the app continue.
     * @param operation - name of the operation that failed
     * @param result - optional value to return as the observable result
     */
    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {

            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead

            // TODO: better job of transforming error for user consumption
            this.log(`${operation} failed: ${error.message}`);

            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }

    /** Log a ScgCompanyService message with the MessageService */
    private log(message: string) {
        console.log(message);
        // this.messageService.add('ScgCompanyService: ' + message);
    }


}



// WEBPACK FOOTER //
// ./src/app/services/quotation.service..ts